import kfetch from '@kareo/kfetch';
import getSessionId from '../utils/sessionId';

const module = {
  load,
  getFeatureSetArea,
};

export default module;

// this would be nice as an async generator instead
let featurePromise;

async function getFeatureSetArea(feature) {
  const features = await load();
  return features[feature];
}

async function load() {
  // caches, only calls once
  if (!featurePromise) {
    featurePromise = getFeatures();
  }

  try {
    return await featurePromise;
  } catch (e) {
    // allow retry on failure
    featurePromise = null;
    return {};
  }
}

async function getFeatures() {
  const sessionId = getSessionId();

  const res = await kfetch(
    `/common-ui/api/Practice/featureSetAreas?sessionId=${encodeURIComponent(
      sessionId,
    )}`,
  );
  return setFeatureSets(res);
}

function setFeatureSets(data) {
  const features = {};

  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      features[key] = extractStatus(data[key]);
    }
  }
  return features;
}

function extractStatus(feature) {
  const status = {};
  if (feature === 'ENABLED') {
    status.show = true;
    status.enabled = true;
  } else if (feature === 'DISABLED') {
    status.show = true;
    status.enabled = false;
  } else if (feature === 'HIDDEN') {
    status.show = false;
  }
  return status;
}
